import { render, staticRenderFns } from "./PostFilter.vue?vue&type=template&id=8ab04bb8&scoped=true&"
import script from "./PostFilter.vue?vue&type=script&lang=js&"
export * from "./PostFilter.vue?vue&type=script&lang=js&"
import style0 from "./PostFilter.vue?vue&type=style&index=0&id=8ab04bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab04bb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VRadio,VRadioGroup,VTooltip})
